"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 0.3rem;\n  font-size: 0.75em;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: ", ";\n  height: 28px;\n  width: 28px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  opacity: 0;\n  cursor: pointer;\n\n  :focus + ", " {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  :focus:invalid {\n    border-color: ", ";\n  }\n\n  :checked + ", " ", " {\n    display: inline-block;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n  stroke-width: 1;\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  stroke: ", ";\n  fill: ", ";\n  stroke-width: 2;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  margin-top: 8px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n\n  opacity: ", ";\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Root = _styledComponents.default.span(_templateObject(), function (props) {
  return props.readonly || props.disabled ? 0.35 : 1;
}, function (props) {
  return props.readonly || props.disabled ? 'not-allowed' : 'default';
});

var Label = _styledComponents.default.label(_templateObject2());

var Svg = _styledComponents.default.svg(_templateObject3(), function (props) {
  return props.forPrint ? '1em' : '28px';
}, function (props) {
  return props.forPrint ? '1em' : '28px';
});

var OuterCircle = _styledComponents.default.circle(_templateObject4(), function (props) {
  return props.forPrint ? '28px' : 'auto';
}, function (props) {
  return props.forPrint ? '28px' : 'auto';
}, function (props) {
  return props.forPrint ? 'black' : props.theme.colorTextPrimary;
}, function (props) {
  return props.forPrint ? 'white' : 'transparent';
});

var InnerCircle = _styledComponents.default.circle(_templateObject5(), function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.colorTextPrimary;
});

var Input = _styledComponents.default.input(_templateObject6(), function (props) {
  return props.forPrint ? 'none' : 'block';
}, Svg, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.theme.colorError;
}, Svg, InnerCircle);

var LabelContent = _styledComponents.default.span(_templateObject7());

var Radio = /*#__PURE__*/function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _getPrototypeOf(Radio).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          label = _this$props.label,
          value = _this$props.value,
          isRequired = _this$props.isRequired,
          onClick = _this$props.onClick,
          readonly = _this$props.readonly,
          disabled = _this$props.disabled,
          forPrint = _this$props.forPrint,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["id", "name", "label", "value", "isRequired", "onClick", "readonly", "disabled", "forPrint", "theme"]);

      return _react.default.createElement(Root, {
        disabled: readonly || disabled,
        className: "hw-radio-wrapper"
      }, _react.default.createElement(Label, {
        className: "hw-radio-wrapper-label"
      }, _react.default.createElement(Input, _extends({
        type: "radio",
        id: id,
        name: name,
        value: value,
        required: isRequired,
        className: "hw-radio",
        onClick: onClick,
        disabled: readonly || disabled,
        forPrint: forPrint,
        theme: theme
      }, otherProps)), _react.default.createElement(Svg, {
        role: "presentation",
        viewBox: "0 0 28 28",
        className: "hw-radio-image",
        focusable: "false",
        forPrint: forPrint
      }, _react.default.createElement(OuterCircle, {
        className: "hw-radio-outer-circle",
        cx: "14",
        cy: "14",
        r: "9",
        forPrint: forPrint,
        theme: theme
      }), _react.default.createElement(InnerCircle, {
        className: "hw-radio-checked",
        cx: "14",
        cy: "14",
        r: "5",
        theme: theme
      })), _react.default.createElement(LabelContent, {
        className: "hw-checkbox-wrapper-label-text"
      }, label)));
    }
  }]);

  return Radio;
}(_react.Component);

Radio.propTypes = {
  id: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  readonly: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  forPrint: _propTypes.default.bool,
  theme: _propTypes.default.shape({
    colorTextPrimary: _propTypes.default.string,
    colorError: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string
  })
};
Radio.defaultProps = {
  isRequired: false,
  readonly: false,
  forPrint: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Radio);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Radio/index.js